// Route protection configuration
export const routeConfig = {
  // Dashboard
  "/app": {
    roles: ["super_admin"],
    permissions: ["dashboard_view"],
  },
  "/app/welcome": {
    roles: ["custom", "super_admin"],
    permissions: [],
  },

  // Statistics
  "/app/statistics/pos_orders": {
    roles: ["super_admin", "admin", "team_leader"],
    permissions: ["statistics_view", "pos_products_payments_report"],
  },
  "/app/statistics/rep_orders": {
    roles: ["super_admin", "admin", "team_leader"],
    permissions: ["statistics_view", "rep_orders_per_days_report"],
  },
  "/app/statistics/rep_pos_e_payments": {
    roles: ["super_admin", "admin", "team_leader"],
    permissions: ["rep_pos_e_payments_report"],
  },

  // Users
  "/app/users": {
    roles: ["super_admin"],
    permissions: ["user_view"],
  },
  "/app/user/Profile": {
    roles: [
      "super_admin",
      "admin",
      "team_leader",
      "representative",
      "wholesale",
    ],
    permissions: [],
  },

  // Tickets
  "/app/tickets": {
    roles: ["super_admin", "team_leader", "admin"],
    permissions: ["ticket_view"],
  },

  // POS
  "/app/pos": {
    roles: ["super_admin", "team_leader", "representative", "admin"],
    permissions: ["pos_view"],
  },

  // Request Points
  "/app/request_points": {
    roles: ["super_admin", "team_leader", "representative", "admin"],
    permissions: ["order_recharge_card_view"],
  },

  // None POS
  "/app/none_pos": {
    roles: ["super_admin", "admin"],
    permissions: ["none_pos_view"],
  },

  // Items
  "/app/items": {
    roles: ["super_admin"],
    permissions: ["item_edit"],
  },

  // Wallets
  "/app/wallets": {
    roles: [
      "super_admin",
      "team_leader",
      "representative",
      "admin",
      "wholesale",
    ],
    permissions: ["user_view"],
  },
  "/app/wallets/pos-transactions": {
    roles: ["super_admin", "admin", "team_leader"],
    permissions: ["wallet_view"],
  },

  // Notifications
  "/app/notification": {
    roles: ["super_admin", "team_leader", "representative", "admin"],
    permissions: ["notification_view"],
  },

  // Orders
  "/app/orders": {
    roles: ["super_admin", "admin"],
    permissions: ["order_view", "order_transfer_view"],
  },

  // Contact Person
  "/app/contact-person": {
    roles: ["super_admin"],
    permissions: [],
  },

  // Leave requests
  "/app/leave": {
    // Anyone who can file their own request — [""] keeps the permission check
    // from ever passing, so access is decided purely by role.
    roles: ["super_admin", "admin", "team_leader", "representative"],
    permissions: [""],
  },
  "/app/leave_admin": {
    roles: ["super_admin"],
    permissions: ["leave_application"],
  },

  // Expenses
  "/app/expense": {
    roles: ["super_admin"],
    permissions: ["spending_view"],
  },

  // External Revenue
  "/app/external_revenue": {
    roles: ["super_admin"],
    permissions: ["revenue_view"],
  },

  // Asia Bills
  "/app/asia_bills": {
    roles: ["asiacell"],
    permissions: [""],
  },

  // SIM Card Transfer
  "/app/sim_card_transfer/sim_card": {
    roles: ["super_admin", "admin"],
    permissions: ["sim_card_view"],
  },
  "/app/sim_card_transfer/operation_transfer": {
    roles: ["super_admin", "admin"],
    permissions: ["operation_transfer_view"],
  },
  "/app/sim_card_transfer/received_sms": {
    roles: ["super_admin", "admin"],
    permissions: [""],
  },

  // Suppliers & Bills
  "/app/suppliers&bills/suppliers": {
    roles: ["super_admin"],
    permissions: ["supplier_view"],
  },
  "/app/suppliers&bills/Investors": {
    roles: ["super_admin"],
    permissions: ["investors_view"],
  },
  "/app/suppliers&bills/capital-amount": {
    roles: ["super_admin"],
    permissions: ["capital_amount_view"],
  },
  "/app/suppliers&bills/capital-amount/transactions/:capital_amount_id": {
    roles: ["super_admin"],
    permissions: ["capital_amount_view"],
  },
  "/app/suppliers&bills/bills": {
    roles: ["super_admin"],
    permissions: ["order_view"],
  },

  // Pins
  "/app/pins/pins": {
    roles: ["super_admin", "admin"],
    permissions: ["pin_view", "operation_view"],
  },
  "/app/pins/operations": {
    roles: ["super_admin", "admin"],
    permissions: ["operation_view"],
  },

  // Payments
  "/app/payments/cards": {
    roles: ["super_admin", "admin"],
    permissions: ["card_view"],
  },
  "/app/payments/order-recharge-cards": {
    roles: ["super_admin", "admin"],
    permissions: ["order_recharge_card_view"],
  },
  "/app/payments/issued_card": {
    roles: ["super_admin", "admin"],
    permissions: ["issued_card_view"],
  },
  "/app/payments/epayment_transactions": {
    roles: ["super_admin", "admin"],
    permissions: ["e_payment_view"],
  },

  // Categories
  "/app/pages/categories": {
    roles: ["super_admin", "admin"],
    permissions: ["category_view"],
  },
  "/app/pages/sub_categories": {
    roles: ["super_admin", "admin"],
    permissions: ["sub_category_view"],
  },

  // Management
  "/app/management/groups": {
    roles: ["super_admin"],
    permissions: ["group_view"],
  },
  "/app/management/banner": {
    roles: ["super_admin"],
    permissions: ["banner_view"],
  },
  "/app/management/pos_types": {
    roles: ["super_admin"],
    permissions: ["pos_type_view"],
  },
  "/app/management/pos_field": {
    roles: ["super_admin"],
    permissions: ["pos_field_view"],
  },
  "/app/management/provinces": {
    roles: ["super_admin"],
    permissions: [""],
  },

  // Reports
  "/app/reports/representative_details": {
    roles: ["super_admin"],
    permissions: ["reports_view", "rep_report"],
  },
  "/app/reports/orders": {
    roles: ["super_admin"],
    permissions: [
      "reports_view",
      "orders_report",
      "orders_pins_details_report",
      "pos_orders_report",
    ],
  },
  "/app/reports/team-leader-orders-per-days": {
    roles: ["super_admin"],
    permissions: ["reports_view", "team_leader_orders_report"],
  },
  "/app/reports/total_revenue": {
    roles: ["super_admin"],
    permissions: ["reports_view", "total_revenue_report"],
  },
  "/app/reports/cash": {
    roles: ["super_admin"],
    permissions: ["reports_view", "cash_report"],
  },
  "/app/reports/totals": {
    roles: ["super_admin"],
    permissions: ["statistics_view", "totals_report"],
  },
  "/app/reports/stock": {
    roles: ["super_admin"],
    permissions: ["reports_view", "stock_report"],
  },
  "/app/reports/platform_payments": {
    roles: ["super_admin"],
    permissions: ["reports_view", "pos_products_payments_report"],
  },
  "/app/reports/pos_e_payments": {
    roles: ["super_admin"],
    permissions: ["reports_view", "pos_e_payments_report"],
  },
  "/app/reports/lazy_pos": {
    roles: ["super_admin"],
    permissions: ["reports_view", "lazy_pos_report"],
  },

  // Platform
  "/app/platform/products": {
    roles: ["super_admin", "admin"],
    permissions: ["product_view"],
  },
  "/app/platform/product_supplier": {
    roles: ["super_admin", "admin"],
    permissions: ["supplier_product_view"],
  },
  "/app/platform/products_orders": {
    roles: ["super_admin", "admin"],
    permissions: ["supplier_product_view"],
  },

  // Wholesale
  "/app/wholesale/j_pos": {
    roles: ["super_admin", "admin", "wholesale"],
    permissions: ["j_pos_view"],
  },
  "/app/wholesale/group": {
    roles: ["super_admin", "admin", "wholesale"],
    permissions: ["j_group_view"],
  },
  "/app/wholesale/categories": {
    roles: ["super_admin", "admin", "wholesale"],
    permissions: ["j_category_view", "j_sub_category_view"],
  },
  "/app/wholesale/items": {
    roles: ["super_admin", "admin", "wholesale"],
    permissions: ["j_item_view"],
  },
  "/app/wholesale/supplier": {
    roles: ["super_admin", "admin", "wholesale"],
    permissions: ["j_supplier_view"],
  },
  "/app/wholesale/invoice": {
    roles: ["super_admin", "admin", "wholesale"],
    permissions: ["j_invoice_view"],
  },
  "/app/wholesale/orders": {
    roles: [
      "super_admin",
      "admin",
      "team_leader",
      "representative",
      "wholesale",
    ],
    permissions: ["j_order_view"],
  },
  "/app/wholesale/order/:order_id": {
    roles: [
      "super_admin",
      "admin",
      "team_leader",
      "representative",
      "wholesale",
    ],
    permissions: ["j_order_view"],
  },
  "/app/wholesale/monthly_target": {
    roles: ["super_admin", "admin"],
    permissions: ["j_monthly_target_view"],
  },
  "/app/wholesale/safe": {
    roles: ["super_admin", "admin", "wholesale"],
    permissions: ["safe_view"],
  },
  "/app/wholesale/expense": {
    roles: ["super_admin", "admin", "wholesale"],
    permissions: ["j_spending_view"],
  },
  "/app/wholesale/reports": {
    roles: ["super_admin", "admin", "wholesale"],
    permissions: [
      "j_report_view",
      "cash_report",
      "j_invoice_item_summary_report",
      "j_item_summary_report",
      "j_item_summary_total_report",
      "j_pos_debt_report",
      "rep_report",
      "rep_statistics_report",
    ],
  },
  "/app/wholesale/supplier_transactions": {
    roles: ["super_admin", "wholesale"],
    permissions: ["supplier_transactions_view"],
  },

  // Settings
  "/app/settings": {
    roles: ["super_admin"],
    permissions: [""],
  },

  // POS External Orders
  "/pos/external-orders": {
    roles: ["pos"],
    permissions: [""],
  },
};

// Function to get route config for a given path
export const getRouteConfig = (path) => {
  // First try exact match
  if (routeConfig[path]) {
    return routeConfig[path];
  }

  // Try to match dynamic routes (routes with parameters like :id)
  for (const routePattern of Object.keys(routeConfig)) {
    if (routePattern.includes(":")) {
      // Convert route pattern to regex
      const regexPattern = routePattern.replace(/:[^/]+/g, "[^/]+");
      const regex = new RegExp(`^${regexPattern}$`);

      if (regex.test(path)) {
        return routeConfig[routePattern];
      }
    }
  }

  // Then try to match parent routes for nested paths
  const pathSegments = path.split("/");
  for (let i = pathSegments.length - 1; i > 0; i--) {
    const parentPath = pathSegments.slice(0, i).join("/");
    if (routeConfig[parentPath]) {
      return routeConfig[parentPath];
    }
  }

  // Default to no restrictions if no config found
  return { roles: [], permissions: [] };
};

// Function to get default route based on user roles
export const getDefaultRoute = (userRoles) => {
  if (!userRoles || userRoles.length === 0) {
    return "/login";
  }

  if (userRoles.includes("super_admin")) {
    return "/app";
  } else if (userRoles.includes("custom")) {
    return "/app/welcome";
  } else if (
    userRoles.includes("representative") ||
    userRoles.includes("team_leader")
  ) {
    return "/app/request_points";
  } else if (userRoles.includes("asiacell")) {
    return "/app/reports/orders";
  } else if (userRoles.includes("admin")) {
    return "/app/users";
  } else if (userRoles.includes("wholesale")) {
    return "/app/wholesale/orders";
  } else if (userRoles.includes("pos")) {
    return "/pos/external-orders";
  } else {
    return "/app/pos";
  }
};
